import { toIpKey } from '@1trading/ts-common/utils';
import type { AbuseSubjectKey } from '@/services/api/abuse';
import { UUID_REGEX } from '@/services/api/users';

export type SubjectQueryKind = 'ip' | 'uuid';

export interface SubjectQuery {
  kind: SubjectQueryKind;
  /** The subjects the query could name, the default first */
  candidates: AbuseSubjectKey[];
}

/** A UUID could be a PID or an API key id, so it offers both, the account first */
export const parseSubjectQuery = (value: string): SubjectQuery | null => {
  const trimmed = value.trim();

  // bop-api matches subject ids exactly, and PIDs are lowercase
  if (UUID_REGEX.test(trimmed)) {
    const subjectId = trimmed.toLowerCase();

    return {
      kind: 'uuid',
      candidates: [
        { subjectType: 'user', subjectId },
        { subjectType: 'apiKey', subjectId },
      ],
    };
  }

  // An IP scores under its key: IPv4 as it is, IPv6 by its /64
  const ipSubjectId = toIpKey(trimmed);

  return ipSubjectId ? { kind: 'ip', candidates: [{ subjectType: 'ip', subjectId: ipSubjectId }] } : null;
};
